import { BaseApiService } from '@/shared/api/BaseApiService';

export interface OrgSettingsDTO {
  id: string;
  displayName: string;
  email: string;
  phone: string | null;
  website: string | null;
  brandLogoUrl: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  state: string | null;
  country: string;
  pinCode: string | null;
  addressId: string | null;
  address: {
    id: string;
    countryId: string;
    stateId: string;
    districtId: string | null;
    line1: string;
    line2: string | null;
    cityTown: string;
    pincode: string;
  } | null;
  status: string;
}

export interface UpdateOrgSettingsInput {
  displayName?: string;
  email?: string;
  phone?: string | null;
  website?: string | null;
  brandLogoUrl?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string;
  pinCode?: string | null;
  address?: {
    countryId: string;
    stateId: string;
    districtId?: string | null;
    line1: string;
    line2?: string | null;
    cityTown: string;
    pincode: string;
  };
}

export class OrganizationService extends BaseApiService {
  protected readonly resourcePath = 'organization';

  async getSettings(): Promise<OrgSettingsDTO> {
    return this.get('/settings');
  }

  async updateSettings(input: UpdateOrgSettingsInput): Promise<OrgSettingsDTO> {
    return this.patch('/settings', input);
  }
}
